import React, { Component } from "react";
import { main_url } from "../../../utils/CommonFunction";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import Select from "react-select";
import DatePicker from "react-datetime";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import { getHeaders } from "../../../utils/apiHelper";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

const numberValue = (value) => Number(value) || 0;
const arrayValue = (value) => (Array.isArray(value) ? value : []);
const metricKeys = [
  "total_amount",
  "gross_salary",
  "deduction_addition_data",
  "after_deduction_or_addition",
  "net_salary",
  "total_gross_salary",
  "deductionTotal",
  "additionTotal",
  "total",
];

const aggregateLineItems = (rows, key, labelKey, valueKey) => {
  const totals = new Map();
  rows.forEach((row) => {
    arrayValue(row[key]).forEach((item) => {
      const label = item[labelKey];
      if (!label) return;
      totals.set(label, (totals.get(label) || 0) + numberValue(item[valueKey]));
    });
  });
  return Array.from(totals, ([label, value]) => ({
    [labelKey]: label,
    [valueKey]: value,
  }));
};

const aggregateRows = (rows, status, locationMasterName = null) => {
  const result = {
    employee_status: status ? Number(status.value) : 0,
    name: status ? status.label : "All",
    location_master_name: locationMasterName,
    addition: aggregateLineItems(
      rows,
      "addition",
      "salary_payment_allowance_label",
      "salary_payment_allowance_value"
    ),
    deduction: aggregateLineItems(
      rows,
      "deduction",
      "salary_payment_deduction_label",
      "salary_payment_deduction_value"
    ),
    ssc: [
      {
        Employer_2: rows.reduce(
          (total, row) => total + numberValue(arrayValue(row.ssc)[0]?.Employer_2),
          0
        ),
        Employee_3: rows.reduce(
          (total, row) => total + numberValue(arrayValue(row.ssc)[0]?.Employee_3),
          0
        ),
      },
    ],
  };
  metricKeys.forEach((key) => {
    result[key] = rows.reduce(
      (total, row) => total + numberValue(row[key]),
      0
    );
  });
  return result;
};

export const buildPayrollSummary = (rows, statuses) => {
  const orderedStatuses = arrayValue(statuses)
    .map((status) => ({ ...status, value: Number(status.value) }))
    .sort((a, b) => a.value - b.value);
  const statusIdByLabel = new Map(
    orderedStatuses.map((status) => [status.label, status.value])
  );
  const normalizedRows = arrayValue(rows).map((row) => ({
    ...row,
    employee_status: Number(
      row.employee_status ?? statusIdByLabel.get(row.name)
    ),
  }));
  const buildStatusRows = (sourceRows, locationMasterName = null) =>
    orderedStatuses.map((status) =>
      aggregateRows(
        sourceRows.filter(
          (row) => Number(row.employee_status) === Number(status.value)
        ),
        status,
        locationMasterName
      )
    );

  const statusDetails = buildStatusRows(normalizedRows);
  const allDetail = aggregateRows(normalizedRows, null);
  const branchMap = normalizedRows.reduce((map, row) => {
    const branchName = row.location_master_name || "-";
    if (!map.has(branchName)) map.set(branchName, []);
    map.get(branchName).push(row);
    return map;
  }, new Map());
  const finalData = Array.from(branchMap, ([branchName, branchRows]) => ({
    branch_name: branchName,
    employeeType: [
      aggregateRows(branchRows, null, branchName),
      ...buildStatusRows(branchRows, branchName),
    ],
  }));

  return { allDetail, finalData, normalizedRows, statusDetails };
};

const uniqueLabels = (rows, key, labelKey) => {
  const labels = [];
  arrayValue(rows).forEach((row) => {
    arrayValue(row[key]).forEach((item) => {
      const label = item[labelKey];
      if (label && !labels.includes(label)) labels.push(label);
    });
  });
  return labels;
};

class PayrollSummaryReportWithLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      regionList: null,
      branchlist: null,
      selected_Branch: null,
      selected_region: null,
      selected_employee_status: null,
      EmployeeStatus: [],
      ReportHeader: [],
      RawData: [],
      FinalData: [],
      AllDetail: aggregateRows([], null),
      StatusDetails: [],
    };
  }

  async componentDidMount() {
    this.$el = $(this.el);
    this.getRegionList();
    this.getBranchList();
    await this.getStatusList();
    this.handleSearchData();
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, { headers: getHeaders() })
      .then((res) => (res.ok ? res.json() : []))
      .then((list) => {
        this.setState({
          branchlist: [{ value: 0, label: "All" }, ...arrayValue(list)],
        });
      });
  }

  getRegionList() {
    fetch(`${main_url}benefit/getRegionList`, { headers: getHeaders() })
      .then((res) => (res.ok ? res.json() : []))
      .then((list) => {
        this.setState({
          regionList: [
            { state_id: 0, state_name: "All", value: 0, label: "All" },
            ...arrayValue(list).map((item) => ({
              ...item,
              label: item.state_name,
              value: item.state_id,
            })),
          ],
        });
      });
  }

  getStatusList() {
    return fetch(`${main_url}benefit/getStatusList`, { headers: getHeaders() })
      .then((res) => (res.ok ? res.json() : []))
      .then(
        (EmployeeStatus) =>
          new Promise((resolve) =>
            this.setState({ EmployeeStatus }, () => resolve(EmployeeStatus))
          )
      );
  }

  getPayrollReportHeader() {
    const date = moment(this.state.date).format("YYYY-MM");
    return fetch(`${main_url}payroll_report/getPayrollReportHeader/${date}`, {
      headers: getHeaders(),
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((ReportHeader) => this.setState({ ReportHeader }));
  }

  handleSelectedBranch = (selected_Branch) => this.setState({ selected_Branch });
  handleSelectedRegion = (selected_region) => this.setState({ selected_region });
  handleEmployeeStatus = (selected_employee_status) =>
    this.setState({ selected_employee_status });
  handleSelectedDate = (date) => this.setState({ date });

  handleSearchData = () => {
    this.getPayrollReportHeader();
    const branchId = this.state.selected_Branch?.value || 0;
    const regionId = this.state.selected_region?.state_id || 0;
    const date = moment(this.state.date).format("YYYY-MM");
    const status = this.state.selected_employee_status?.value || 0;
    return fetch(
      `${main_url}payroll_report/payrollWiseLocationReport/${date}/${regionId}/${branchId}/${status}`,
      { headers: getHeaders() }
    )
      .then((res) => (res.ok ? res.json() : []))
      .then((rows) => {
        const summary = buildPayrollSummary(rows, this.state.EmployeeStatus);
        this.setState({
          RawData: summary.normalizedRows,
          FinalData: summary.finalData,
          AllDetail: summary.allDetail,
          StatusDetails: summary.statusDetails,
        });
        return summary;
      });
  };

  lineItemValue(row, key, labelKey, valueKey, label) {
    const item = arrayValue(row[key]).find((entry) => entry[labelKey] === label);
    return item ? numberValue(item[valueKey]) : 0;
  }

  renderReportRow({
    row,
    key,
    location,
    locationRowSpan,
    grandTotal,
    deductionLabels,
    additionLabels,
  }) {
    return (
      <tr key={key} style={{ textAlign: "center" }}>
        {location ? (
          <td rowSpan={locationRowSpan} style={{ verticalAlign: "middle" }}>
            {location}
          </td>
        ) : null}
        <td style={{ verticalAlign: "middle" }}>{row.name}</td>
        <td style={{ verticalAlign: "middle" }}>{row.gross_salary}</td>
        <td style={{ verticalAlign: "middle" }}>{row.deduction_addition_data}</td>
        <td style={{ verticalAlign: "middle" }}>{row.after_deduction_or_addition}</td>
        <td style={{ verticalAlign: "middle" }}>{row.ssc[0].Employer_2}</td>
        <td style={{ verticalAlign: "middle" }}>{row.ssc[0].Employee_3}</td>
        <td style={{ verticalAlign: "middle" }}>
          {this.lineItemValue(
            row,
            "deduction",
            "salary_payment_deduction_label",
            "salary_payment_deduction_value",
            "Income Tax"
          )}
        </td>
        <td style={{ verticalAlign: "middle" }}>{row.net_salary}</td>
        <td style={{ verticalAlign: "middle" }}>{row.total_gross_salary}</td>
        {deductionLabels.map((label) => (
          <td key={`deduction-${key}-${label}`} style={{ verticalAlign: "middle" }}>
            {this.lineItemValue(
              row,
              "deduction",
              "salary_payment_deduction_label",
              "salary_payment_deduction_value",
              label
            )}
          </td>
        ))}
        {additionLabels.map((label) => (
          <td key={`addition-${key}-${label}`} style={{ verticalAlign: "middle" }}>
            {this.lineItemValue(
              row,
              "addition",
              "salary_payment_allowance_label",
              "salary_payment_allowance_value",
              label
            )}
          </td>
        ))}
        <td style={{ verticalAlign: "middle" }}>{row.total}</td>
        {grandTotal !== undefined ? (
          <td rowSpan={locationRowSpan} style={{ verticalAlign: "middle" }}>
            {grandTotal}
          </td>
        ) : null}
      </tr>
    );
  }

  render() {
    const {
      AllDetail,
      EmployeeStatus,
      FinalData,
      RawData,
      ReportHeader,
      StatusDetails,
    } = this.state;
    const configuredLabels = new Set(
      arrayValue(ReportHeader)
        .filter((header) => header.label !== "Income Tax" && header.label !== "SSC")
        .map((header) => header.label)
    );
    const includeConfiguredLabel = (label) =>
      configuredLabels.size === 0 || configuredLabels.has(label);
    const deductionLabels = uniqueLabels(
      RawData,
      "deduction",
      "salary_payment_deduction_label"
    ).filter(
      (label) =>
        label !== "Income Tax" && label !== "SSC" && includeConfiguredLabel(label)
    );
    const additionLabels = uniqueLabels(
      RawData,
      "addition",
      "salary_payment_allowance_label"
    ).filter(includeConfiguredLabel);
    const allianceRows = [AllDetail, ...StatusDetails];

    return (
      <div>
        <div className="row white-bg dashboard-header">
          <h3 style={{ paddingLeft: 10 }}>
            Payroll Summary Report With Location Wise/Status Wise
          </h3>
          <div style={{ overflow: "scroll" }}>
            <div className="row" style={{ marginBottom: 10 }}>
              <div className="col-md-12" style={{ marginBottom: 10 }}>
                <div
                  className="flex-row"
                  style={{ display: "flex", justifyContent: "left", alignItems: "center" }}
                >
                  <DatePicker
                    dateFormat="YYYY-MM"
                    value={this.state.date}
                    onChange={this.handleSelectedDate}
                    timeFormat={false}
                  />
                  <Select
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: 150,
                        marginRight: 10,
                        marginLeft: 10,
                      }),
                      control: (base) => ({ ...base, minHeight: 18 }),
                    }}
                    placeholder="Branch"
                    options={this.state.branchlist}
                    onChange={this.handleSelectedBranch}
                    value={this.state.selected_Branch}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  <Select
                    styles={{
                      container: (base) => ({ ...base, width: 150, marginRight: 10 }),
                      control: (base) => ({ ...base, minHeight: 18 }),
                    }}
                    placeholder="Region"
                    options={this.state.regionList}
                    onChange={this.handleSelectedRegion}
                    value={this.state.selected_region}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  <Select
                    styles={{
                      container: (base) => ({ ...base, width: 150 }),
                      control: (base) => ({ ...base, minHeight: 18 }),
                    }}
                    placeholder="Employee Status"
                    options={EmployeeStatus}
                    onChange={this.handleEmployeeStatus}
                    value={this.state.selected_employee_status}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                  <button
                    className="btn btn-primary text-center"
                    style={{ marginLeft: 10, height: 30, padding: "0 5px" }}
                    onClick={this.handleSearchData}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="col-md-12 btn-leftend">
                <ReactHTMLTableToExcel
                  className="btn-excel"
                  table="reg_wise_staff"
                  filename={`Payroll Summary Report With Location Wise/Status Wise-${moment(
                    this.state.date
                  ).format("YYYY-MM")}`}
                  buttonText="Excel"
                  sheet="Sheet"
                />
              </div>
            </div>
            <table className="table table-bordered" id="reg_wise_staff">
              <thead>
                <tr>
                  <th rowSpan={2}>Region/Branch</th>
                  <th rowSpan={2}>Employee Status</th>
                  <th rowSpan={2}>Gross Salary</th>
                  <th rowSpan={2}>Deductions(+)/Additions(-)</th>
                  <th rowSpan={2}>Salary After Deductions/Additions</th>
                  <th colSpan={2}>SSC</th>
                  <th rowSpan={2}>Income Tax</th>
                  <th rowSpan={2}>Net Salary Paid</th>
                  <th rowSpan={2}>Total Gross Salary</th>
                  {deductionLabels.map((label) => (
                    <th key={`deduction-header-${label}`} rowSpan={2}>{label}</th>
                  ))}
                  {additionLabels.map((label) => (
                    <th key={`addition-header-${label}`} rowSpan={2}>{label}</th>
                  ))}
                  <th rowSpan={2}>Total</th>
                  <th rowSpan={2}>Grand Total</th>
                </tr>
                <tr>
                  <th>Employer 3%</th>
                  <th>Employee 2%</th>
                </tr>
              </thead>
              <tbody>
                {FinalData.length > 0
                  ? allianceRows.map((row, index) =>
                      this.renderReportRow({
                        row,
                        key: `alliance-${row.employee_status}`,
                        location: index === 0 ? "All Alliance" : null,
                        locationRowSpan: allianceRows.length,
                        grandTotal: index === 0 ? AllDetail.total : undefined,
                        deductionLabels,
                        additionLabels,
                      })
                    )
                  : null}
                {FinalData.map((branch) =>
                  branch.employeeType.map((row, index) =>
                    this.renderReportRow({
                      row,
                      key: `${branch.branch_name}-${row.employee_status}`,
                      location: index === 0 ? branch.branch_name : null,
                      locationRowSpan: branch.employeeType.length,
                      grandTotal:
                        index === 0 ? branch.employeeType[0].total : undefined,
                      deductionLabels,
                      additionLabels,
                    })
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default PayrollSummaryReportWithLocation;
